import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import * as actions from '../../../actions/response';

const classButtonInactive = 'btn btn-default close-modal btn-block';
const classButtonActive = 'btn btn-primary close-modal btn-block';

class ModalConfirmSimple extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      waitingResponse: false,
      message: this.getInitMessage(),
      onResponse: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  closeModal() {
    this.props.closeModal('ConfirmSimple');
  }

  onCancel() {
    if (this.props.onLeftButtonClick) this.props.onLeftButtonClick();
    this.closeModal();
  }

  onSuccess(data) {
    data.message = data.message || 'Suscripción cancelada';
    this.setState({ message: data.message });
    this.removeLoader();
  }

  onFailed(data) {
    data.message = data.message || 'Error';
    this.setState({ message: data.message });
    this.setState({ onResponse: true });
  }

  onConfirm() {
    this.props.onRightButtonClick();
    // this.setLoader();
    // this.removeLoader();
  }

  removeLoader() {
    this.setState({ waitingResponse: false });
    this.setState({ onResponse: true });
  }

  setLoader() {
    this.setState({ waitingResponse: true });
    const message = (
      <div>
        <p> Cargando ... </p>
      </div>
    );
    this.setState({ message });
  }

  getInitMessage() {
    return (
      <div>
        <i
          className="fa text-center fa-3x fa-exclamation-triangle"
          aria-hidden="true"
        />
        <p
          className="padding-top-2"
          dangerouslySetInnerHTML={{ __html: this.props.message }}
        />
      </div>
    );
  }

  render() {
    return (
      <Modal show>
        <Modal.Header>
          <Button className="close close-modal" onClick={this.closeModal}>
            x
          </Button>
          <h4 className="text-left">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className="modal-body text-center success">
          {this.state.message}
        </Modal.Body>
        <Modal.Footer>
          {!this.state.waitingResponse && (
            <div className="footer-modal-button flex-end">
              {this.props.rightButtonTitle && (
                <div className="col-lg-3 col-md-3 col-sm-4 col-xs-4 padding-top-05">
                  <Button
                    className={classButtonActive}
                    onClick={this.onConfirm}
                  >
                    {this.props.rightButtonTitle}
                  </Button>
                </div>
              )}
              {this.props.leftButtonTitle && (
                <div className="col-lg-3 col-md-3 col-sm-4 col-xs-4 padding-top-05">
                  <Button
                    className={classButtonInactive}
                    onClick={this.onCancel}
                  >
                    {this.props.leftButtonTitle}
                  </Button>
                </div>
              )}
            </div>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
  router: state.routing,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalConfirmSimple);
